// src/pages/BlogPostScreen.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useApp } from '../lib/AppContext';

export default function BlogPostScreen() {
  const { slug } = useParams();
  const { lang } = useApp();
  const [post, setPost] = useState(null);

  useEffect(() => {
    supabase.from('blog_posts').select('*').eq('slug', slug).eq('published', true).single()
      .then(({ data }) => setPost(data));
  }, [slug]);

  if (!post) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'60vh' }}><div className="spinner" /></div>;

  return (
    <div style={{ maxWidth: 760, margin:'0 auto', padding:'40px 24px 64px' }}>
      {post.cover_image && <img src={post.cover_image} alt="" style={{ width:'100%', height:300, objectFit:'cover', borderRadius:16, marginBottom:32 }} />}
      <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:'.72rem', fontWeight:700, letterSpacing:'.2em', textTransform:'uppercase', color:'#4cca74', marginBottom:10 }}>
        {post.category} · {post.read_time_minutes} min read
      </div>
      <h1 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:'clamp(1.8rem,4vw,2.8rem)', fontWeight:700, lineHeight:1.1, marginBottom:14 }}>
        {post.title?.[lang] || post.title?.en}
      </h1>
      <div style={{ fontSize:'.82rem', color:'#444', marginBottom:32 }}>
        {new Date(post.created_at).toLocaleDateString('en-GB', { day:'numeric', month:'long', year:'numeric' })}
      </div>
      <div
        style={{ color:'#999', fontSize:'.95rem', fontWeight:300, lineHeight:2 }}
        dangerouslySetInnerHTML={{ __html: (post.content?.[lang] || post.content?.en || '').replace(/\n/g, '<br>') }}
      />
    </div>
  );
}
